// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    checkAccess,
    fetchAsset,
    openModal,
    getBranding,
    setForm,
    closeModal,
} from '../../actions';
import Content from './Content';
import Loader from '../../ui/components/Loader';
import { Preview } from '../../ui/components/Preview';
import { getAssetForId } from '../../selectors/assets';
import { PRICE_OPTS_FORM } from '../../constants/forms';

type Props = {
    id: number,
    auth: {
        isLoading: boolean,
    },
    clientID: string,
    brandingId: string,
    branding: {
        paywall_primary_color: string,
    },
    noPreview: boolean,
    options: Object,
    checkAccess: Function,
    fetchAsset: Function,
    openModal: Function,
    getBranding: Function,
    fetchAccessFees: Function,
    selectFee: Function,
    freemium: Function,
    modal: {
        isTriggerExternal: boolean,
    },
    asset: Object,
    assets: {
        id: number,
        isFetching: boolean,
    },
    isExternal: boolean,
    setForm: Function,
    closeModal: Function,
};

export class Container extends Component<Props> {
    componentDidMount() {
        const { id, clientID, brandingId, isExternal } = this.props;

        if (!isExternal) this.props.fetchAsset(id, clientID);

        this.props.getBranding(clientID, brandingId);
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const { auth, id, clientID, brandingId, asset } = this.props;

        if (
            asset &&
            !asset.isFetching &&
            !auth.isAuthenticated &&
            nextProps.auth.isAuthenticated
        ) {
            //check access when the user authenticates..
            this.props.checkAccess(
                id,
                clientID,
                (activeAssetID, hasAccess, isTriggerExternal) => {
                    if (isTriggerExternal) {
                        this.props.closeModal();
                        return;
                    }

                    if (id === activeAssetID) {
                        if (!hasAccess) {
                            this.props.setForm(PRICE_OPTS_FORM);
                            this.props.openModal(activeAssetID);
                        } else this.props.closeModal();
                    }
                }
            );
        }
    }

    render() {
        const {
            asset,
            auth,
            noPreview,
            branding,
            options,
            isFetching: isFetchingAsset,
            isLoading: isLoadingUser,
        } = this.props;

        const { paywall_primary_color } = branding;

        if (isFetchingAsset || isLoadingUser) {
            return <Loader iconColor={paywall_primary_color || '#00aae6'} />;
        }

        if (auth.isAuthenticated && asset && asset.hasAccess) {
            return <Content asset={asset} options={options} />;
        }

        if (asset && !noPreview) {
            return (
                <Preview
                    asset={this.props.asset}
                    openModal={this.props.openModal}
                    branding={branding}
                />
            );
        }

        return null;
    }
}

const mapStateToProps = (state: Object, ownProps: Object) => {
    return {
        isLoading: state.auth.isLoading,
        isFetching: state.assets.isFetching,
        asset: getAssetForId(ownProps.id)(state),
        clientID: state.paywall.clientID,
        auth: state.auth,
        branding: state.branding,
    };
};

export default connect(
    mapStateToProps,
    {
        checkAccess,
        fetchAsset,
        openModal,
        getBranding,
        setForm,
        closeModal,
    }
)(Container);



// WEBPACK FOOTER //
// ./src/containers/Asset/Container.js